import * as Countries from "./Countries";
import * as Channels from "./Channels";
import * as OrderStatuses from "./OrderStatuses";
import * as dishTypes from "./dishTypes";
import * as Batches from "./Batches";
import * as Days from "./Days";
import * as Roles from "./Roles";
import * as Rules from "./Rules";
import * as BusinessTypes from "./BusinessTypes";
import * as Colors from "./Colors";
import * as OrderTypes from "./OrderTypes";
import * as NotificationEvents from "./NotificationEvents";
import * as PackagingSlabs from "./PackagingSlabs";
export const Constants = {
  Countries,
  Channels,
  OrderStatuses,
  dishTypes,
  Batches,
  Days,
  Roles,
  Rules,
  BusinessTypes,
  Colors,
  OrderTypes,
  NotificationEvents,
  PackagingSlabs
};
